import { useEffect } from "react";

export const AI_MEETING_CONTENT_CHANGED_EVENT = "ai-meeting-content-changed";
export const AI_MEETING_CONTENT_TOOLS = new Set([
  "link_chat_attachment_to_meeting",
  "generate_file_note",
]);

interface MeetingContentChangedDetail {
  meetingId?: string;
  recordingId?: string;
  fileName?: string;
  transcriptImported?: boolean;
  transcriptionQueued?: boolean;
  transcriptionWarning?: string;
  jobId?: string;
  transcriptionId?: string;
  templateId?: string;
  templateName?: string;
}

export function useMeetingContentChangeListener(
  meetingId: string | undefined,
  onChanged: (detail: MeetingContentChangedDetail) => void,
) {
  useEffect(() => {
    const handler = (event: Event) => {
      const detail = (event as CustomEvent<MeetingContentChangedDetail>).detail || {};
      if (!meetingId || String(detail.meetingId) !== String(meetingId)) return;
      onChanged(detail);
    };

    window.addEventListener(AI_MEETING_CONTENT_CHANGED_EVENT, handler);
    return () => window.removeEventListener(AI_MEETING_CONTENT_CHANGED_EVENT, handler);
  }, [meetingId, onChanged]);
}
